// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.cp_level_enum */
var CpLevelEnum;
(function (CpLevelEnum) {
    CpLevelEnum["CRITICAL"] = "CRITICAL";
    CpLevelEnum["OPRP_MAJOR"] = "OPRP_MAJOR";
    CpLevelEnum["OPRP_MINOR"] = "OPRP_MINOR";
    CpLevelEnum["QCP_MAJOR"] = "QCP_MAJOR";
    CpLevelEnum["QCP_MINOR"] = "QCP_MINOR";
})(CpLevelEnum || (CpLevelEnum = {}));
;
export default CpLevelEnum;
/** Zod schema for cp_level_enum */
export const cpLevelEnum = z.nativeEnum(CpLevelEnum);
//# sourceMappingURL=CpLevelEnum.js.map